"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackAnEcomEventForOrderId = exports.TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId = void 0;

var _has = _interopRequireDefault(require("lodash/has"));

var _get = _interopRequireDefault(require("lodash/get"));

var _map = _interopRequireDefault(require("lodash/map"));

var _urlHelper = require("./../../helpers/url-helper");

var _raygunHelper = require("./../../helpers/apm/raygun-helper");

var _fetch = _interopRequireDefault(require("./../../fetch"));

var _runtimeConfigHelper = require("./../../helpers/runtime-config-helper");

var allreadyTrackedOrderIds = [];

var TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId = function TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId(path, analyticsService) {
  var queries = (0, _urlHelper.getQueryParametersFromUrl)(path);

  if ((0, _has["default"])(queries, 'successOrderId')) {
    var orderId = (0, _get["default"])(queries, 'successOrderId');
    TrackAnEcomEventForOrderId(orderId, analyticsService);
  }
};

exports.TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId = TrackAnEcomEventWhenTheUrlContainsAnSuccessOrderId;

var TrackAnEcomEventForOrderId = function TrackAnEcomEventForOrderId(orderId, analyticsService, callback) {
  allreadyTrackedOrderIds.push(orderId);
  var url = (0, _urlHelper.getBaseUrl)(_urlHelper.siteNames.API);
  (0, _fetch["default"])("".concat(url, "/v1.0/billing/order_info?orderId=").concat(orderId), {
    credentials: 'include'
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    var totalPriceExTax = (0, _get["default"])(data, 'total_price');
    var totalTax = (0, _get["default"])(data, 'total_tax');
    var status = (0, _get["default"])(data, 'status');
    var products = (0, _map["default"])((0, _get["default"])(data, 'items'), function (item) {
      return {
        productId: item.sku,
        productName: item.name,
        productTerm: item.term,
        productQuantity: item.quantity,
        productPrice: item.price,
        productTax: item.tax,
        productBrand: (0, _runtimeConfigHelper.getRuntimeConfig)()._brand
      };
    });

    if (analyticsService) {
      analyticsService.trackEcommercePurchase(orderId, totalPriceExTax, totalTax, status, products);
    }

    if (callback) {
      callback();
    }
  })["catch"](function (error) {
    (0, _raygunHelper.error)(error);

    if (callback) {
      callback();
    }
  });
};

exports.TrackAnEcomEventForOrderId = TrackAnEcomEventForOrderId;